import { render, staticRenderFns } from "./serial.vue?vue&type=template&id=f8935f28&scoped=true&"
import script from "./serial.vue?vue&type=script&lang=js&"
export * from "./serial.vue?vue&type=script&lang=js&"
import style0 from "./serial.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./serial.vue?vue&type=style&index=1&id=f8935f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8935f28",
  null
  
)

export default component.exports